import { Box, Typography } from '@mui/material'
import React from 'react'
import { useLocation } from 'react-router-dom' // Import useLocation
import { BackgroundVideo, Navbar } from '../'
import { about5, serviceHero, project1, careerHero, contact1 } from '../../assets'

const Hero = () => {
    const location = useLocation() // Get the current path

    const page = [
        {
            name: 'about us',
            text: "From Vision to reality—Pangu delivers. \n\n From small-scale renovations, to large-scale multi-million projects, Pangu Enterprises is equipped to handle it all. Whether it's innovative modular construction, advanced digital solutions, or eco-friendly building practices, we deliver results that exceed expectations.",
            path: '/about',
            video: about5,
        },
        {
            name: 'services',
            text: "Building with Purpose, Precision, and Passion. \n\n Discover our wide range of construction and design services tailored to meet the unique needs of every project. At Pangu Enterprises, we turn ideas into lasting, high-quality spaces.",
            path: '/services',
            video: serviceHero,
        },
        {
            name: 'projects',
            text: "Every Project tells a story of dedication, craftmanship and innovation. At Pangu Enterprises, we transform ideas into reality, delivering exceptional Residential, Commercial, Industrial spaces and more. Explore our portfolio and experience the quality and precision that set us apart.",
            path: '/projects',
            video: project1,
        },
        {
            name: 'career',
            text: "From Vision to Reality — Pangu Delivers. \n\n From small-scale renovations, to multi-million-dollar projects, Pangu Enterprises is equipped to handle it all. Inovatove Modular Construction, Advanced Digital Solutions, or Eco-friendly Building Practices, we deliver results that exceed your expectations.",
            path: '/career',
            video: careerHero,
        },
        {
            name: 'offers',
            text: "From Vision to Reality — Pangu Delivers. \n\n From small-scale renovations, to multi-million-dollar projects, Pangu Enterprises is equipped to handle it all. Inovatove Modular Construction, Advanced Digital Solutions, or Eco-friendly Building Practices, we deliver results that exceed your expectations.",
            path: '/career/offers',
            video: careerHero,
        },
        {
            name: 'contact us',
            text: "Have a project in mind? We're here to help. Whether you're looking to build, renovate, or explore construction possibilities, our team is ready to assist. \n\n Contact Us today to discuss your vision and take the next step towards your dream project.",
            path: '/contact',
            video: contact1,
        },
    ]

    // Find the page object that matches the current path
    const currentPage = page.find((item) => item.path === location.pathname)

    return (
        <Box
            sx={{
                width: '100%',
                minHeight: '100vh', // Ensures it takes full screen height
                overflow: 'hidden', // Prevents unwanted extra space
                position: 'relative', // Ensures children don't overflow
            }}
        >
            {currentPage && (
                <React.Fragment>
                    <BackgroundVideo video={currentPage.video} />
                    <Box
                        sx={{
                            width: '100%',
                            minHeight: '100vh',
                            background: 'linear-gradient(to right, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0))',
                            position: 'absolute',
                            zIndex: '1000',
                        }}
                    >
                        <Navbar />
                        <Box
                            sx={{
                                display: 'flex',
                                marginY: '2rem',
                                background: 'linear-gradient(to top, rgba(109, 116, 198, 1),  rgba(109, 116, 198, 0))',
                                width: '30%',
                                justifyContent: 'center',
                                paddingY: '4rem',
                                paddingX: '1rem',
                                minHeight: '100%',
                                '@media screen and (max-width:762px)': {
                                    padding: '2rem 0',
                                    width: '70%',
                                    boxSizing: 'border-box',
                                },
                            }}
                        >
                            <Typography
                                variant="h1"
                                sx={{
                                    fontSize: '3.5rem',
                                    textTransform: 'capitalize',
                                    fontFamily: 'var(--title-font)',
                                    color: '#fefefe',
                                    fontWeight: '500',
                                    '@media screen and (max-width:762px)': {
                                        fontSize: '3rem',
                                        paddingX: '1rem',
                                    },
                                }}
                            >
                                {currentPage.name}
                            </Typography>
                        </Box>

                        <Box
                            sx={{
                                width: '70%',
                                padding: '2rem',
                                marginY: '5rem',
                                boxSizing: 'border-box',
                                background: 'linear-gradient(to right, rgba(109, 116, 198, 1),  rgba(109, 116, 198, 0))',
                            }}
                        >
                            <Typography
                                sx={{
                                    fontSize: '1.3rem',
                                    color: '#fefefe',
                                    fontFamily: 'var(--text-font)',
                                    '@media screen and (max-width: 762px)': {
                                        fontSize: '1rem',
                                    },
                                }}
                            >
                                {currentPage.text.split('\n\n').map((line, index) => (
                                    <React.Fragment key={index}>
                                        {line}
                                        <br />
                                        <br />
                                    </React.Fragment>
                                ))}
                            </Typography>
                        </Box>
                    </Box>
                </React.Fragment>
            )}
        </Box>
    )
}

export default Hero